import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class SalesforceIdentityToken {
  token = ""
}

export const SALESFORCE_IDENTITY_TOKEN_DESER: SchemaDeSer<SalesforceIdentityToken> =
  new SchemaDeSerBuilder(SalesforceIdentityToken).ofString("token").toDeSer()
